import { Video } from "@kalyzee/kast-web-sdk/web-components";
import { PlayerContainerRenderer } from "./interfaces";

export interface VideoPlayerProps {
  src: MediaStream;
  poster?: string;
  muted?: boolean;
  videoStyle?: React.CSSProperties;
  renderCustomContainer?: PlayerContainerRenderer;
}

export const VideoPlayer = ({ src, poster, muted, videoStyle = {}, renderCustomContainer }: VideoPlayerProps) => {
  const renderContent = () => {
    return <Video poster={poster} muted={muted} style={{ width: "100%", height: "100%", ...videoStyle }} src={src} autoPlay playsInline />;
  };
  if (renderCustomContainer) {
    return <>{renderCustomContainer(renderContent())}</>;
  }
  return renderContent();
};
